import { Typography } from "@mui/material"
import React from "react"
import { motion } from "framer-motion"
import { useInView } from "react-intersection-observer"
import "./Fast.css"

const Fast = () => {
  let { ref, inView, entry } = useInView()
  return (
    <motion.div
      ref={ref}
      className="fast_container"
      initial={inView === false ? { y: 30, opacity: 0 } : {}}
      animate={inView === true ? { y: 0, opacity: 1 } : {}}
      transition={{ bounce: false, type: "spring", stiffness: 30 }}
    >
      <div className="custom_main_container">
        <Typography variant="h4">
        About Us
        </Typography>
        <Typography variant="body1">
        Apace Refunds was created by a small but passionate team in Miami, Florida. The creators recognized a gap in the shopping experience when it drastically changed in the transition to eCommerce.
        </Typography>
        <Typography variant="body1">
        As online purchases increase, so do returns. This means that both customers and retailers need a solution for when their funds are tied up during this period. The mission of Apace Refunds is to replicate the dressing room try-on experience for eCommerce purchases in the comfort of a customer’s home. Apace strives to enable customers to have optionality, knowing that their refunds won’t be tied up if they choose to return the items. We believe that customers should be comfortable with their liquidity, ultimately making better decisions with the quantity and timing of their purchases. 
        </Typography>
        <Typography variant="body1">
        Apace headquarters is now located in New York. Our team is growing, but so is our commitment to our mission.
        </Typography>
      </div>
    </motion.div>
  )
}

export default Fast
